import React from "react";
import CheckoutNote from "./CheckoutNote";

export default function MakeModelSerial() {
  return (
    <CheckoutNote icon="lightbulb-on" title="Why add Make/Model/Serial#?">
      Including information about the assembly you are repairing helps us ensure that you get the right parts.
    </CheckoutNote>
  );
}
